import React, { useState, useRef, useEffect } from "react";
import "antd/dist/antd.css";
import { IMaskInput } from "react-imask";
import * as util from "../Helpers/Util";
import { loadCaptchaEnginge, LoadCanvasTemplate,validateCaptcha } from "react-simple-captcha";

import { Button, Form, Input, Row, Col, message, Spin } from "antd";
import KullaniciEkle from "../../services/kullaniciEkle";
import GetHashKey from "../../services/getHashKey";
const formLayout = {
  labelCol: {
    span: 6,
  },
  wrapperCol: {
    span: 16,
  },
};
const formItemStyle = {
  marginLeft: 10,
};

const KullaniciEkleForm = () => {
  const ref = useRef(null);
  const [form] = Form.useForm();

  const [spining, setSpining] = useState(false);
  const [hasVerify, setHasVerify] = useState(false);
  const [verifyCode, setVerifyCode] = useState();
  const [hashKey,setHashKey] = useState();

    const getHashKey = () => {
        GetHashKey().then(resp => {
            if(resp.data.success){
                setHashKey(resp.data.result);
            }
            
        });
    }


    const successMessage = (msg) => {
        message.success(msg);
    }

    const errorMessage = (msg) => {
        message.error(msg);
    }

  useEffect(() => {
    getHashKey();
    loadCaptchaEnginge(6);
  }, []);

  const onFinish = async (values) => {
    setSpining(true);
    if(hasVerify){
        if(checkHasVerify(values['hasVerify'])){
            addUser(values);
        }else{
            errorMessage("SMS doğrulama hatası. Lütfen tekrar deneyiniz.");
            setSpining(false);
        }
    }else if(validateCaptcha(values["captcha"])){
        addUser(values);
    }
    else {
        errorMessage("Karakter Tanımlama Eşleşmedi");
        loadCaptchaEnginge(6);
        setSpining(false); 
    }
    
   
  };

  const addUser = async (data) => {

    data["phone"] = data["phone"].replace(/[^\d]/g, "");
    data["hasVerify"] = hasVerify;
    data["password"] = util.encryptUsingAES256(data["password"],hashKey);
    data["confirm"] = util.encryptUsingAES256(data["confirm"],hashKey);
    
    await KullaniciEkle(data)
      .then((resp) => {
        if (!resp.data.success) {
          loadCaptchaEnginge(6);
          errorMessage(resp.data.message);
        } else {
            if(!hasVerify){
                setHasVerify(true);
                setVerifyCode(util.decryptUsingAES256(resp.data.result.verifyCode,hashKey));
            }else{
                successMessage("Yeni kullanıcı oluşturulmuştur.");
                setHasVerify(false);
                form.resetFields();
            }
        }
      })
      .catch((ex) => {
        console.log(ex);
        
      });

      setSpining(false);
     
  };

  const checkHasVerify = (val) => {
    if (val == verifyCode ) {
      return true;
    } else {
      return false;
    }
  };

  const validatePassword = (rule, value, callback) => {
    
    var message = util.validatePassword(value);
        
    if(!util.isNullOrEmptyOrUndefined(message)){
      callback(message);
    }      
    else {
      callback();   
    }
      
        
  };

  return (
    <Spin
      tip={"Kullanıcı Kayıt İşlemi Yapılıyor. Lütfen Bekleyiniz"}
      spinning={spining}
    >
      <Form
        {...formLayout}
        style={{ marginTop: 30 }}
        form={form}
        name="register"
        onFinish={onFinish}
        scrollToFirstError
      >
        <Form.Item
          name="tckn"
          label="TCKN"
          style={formItemStyle}
          labelAlign="left"
          rules={[
            {
              required: true,
              message: "TCKN Zorunludur!",
            },
            {
              min: 11,
              max: 11,
              message: "Geçerli TCKN Giriniz!",
            },
          ]}
        >
          <IMaskInput
            mask="00000000000"
            maxLength={11}
            unmask={true}
            style={{ width: "100%" }}
            disabled={hasVerify ? true : false}
            ref={ref}
          />
        </Form.Item>

        <Form.Item
          name="name"
          label="Ad"
          style={formItemStyle}
          labelAlign="left"
          rules={[
            {
              required: true,
              message: "Ad Zorunludur!",
              whitespace: true,
            },
          ]}
        >
          <Input disabled={hasVerify ? true : false} />
        </Form.Item>
        <Form.Item
          name="lastname"
          label="Soyad"
          style={formItemStyle}
          labelAlign="left"
          rules={[
            {
              required: true,
              message: "Soyad Zorunludur!",
              whitespace: true,
            },
          ]}
        >
          <Input disabled={hasVerify ? true : false} />
        </Form.Item>
        <Form.Item
          name="phone"
          label="GSM"
          style={formItemStyle}
          labelAlign="left"
          rules={[
            {
              required: true,
              message: "GSM Zorunludur!",
            },
          ]}
        >
          <IMaskInput
            mask="(000) 000-0000"
            unmask={false}
            style={{ width: "100%" }}
            disabled={hasVerify ? true : false}
            ref={ref}
          />
        </Form.Item>
        <Form.Item
          name="email"
          label="E-mail"
          style={formItemStyle}
          labelAlign="left"
          rules={[
            {
              type: "email",
              message: "Geçerli E-Posta Giriniz",
            },
            {
              required: true,
              message: "E-Posta Zorunludur!",
            },
          ]}
        >
          <Input disabled={hasVerify ? true : false} />
        </Form.Item>

        <Form.Item
          name="password"
          label="Şifre"
          style={formItemStyle}
          labelAlign="left"
          rules={[
            {
              required: true,
              message: "Şifre Zorunludur!",
            },
            { validator: validatePassword }
          ]}
          hasFeedback
        >
          <Input.Password disabled={hasVerify ? true : false} />
        </Form.Item>

        <Form.Item
          name="confirm"
          label="Şifre Tekrarı"
          style={formItemStyle}
          labelAlign="left"
          dependencies={["password"]}
          hasFeedback
          rules={[
            {
              required: true,
              message: "Şifre Tekrarı Zorunludur!",
            },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue("password") === value) {
                  return Promise.resolve();
                }

                return Promise.reject(
                  new Error("Girdiğiniz Parolalar Eşleşmiyor!")
                );
              },
            }),
          ]}
        >
          <Input.Password disabled={hasVerify ? true : false} />
        </Form.Item>

        <Form.Item
          label="Karakter Tanımlama"
          extra="Resimdeki karakterleri giriniz!"
          style={formItemStyle}
          labelAlign="left"
        >
          <Row gutter={8}>
            <Col span={12}>
              <Form.Item
                name="captcha"
                noStyle
                rules={[
                  {
                    required: true,
                    message: "Karakter Tanımlama Zorunludur!",
                  },
                ]}
              >
                <Input disabled={hasVerify ? true : false} />
              </Form.Item>
            </Col>
            <Col span={12}>
              <LoadCanvasTemplate reloadText="Karakteri Değiştir" />
            </Col>
          </Row>
        </Form.Item>
        {hasVerify && (
          <Form.Item
            name="hasVerify"
            label="SMS Doğrulama"
            style={formItemStyle}
            labelAlign="left"
            validateStatus="error"
            help="İşleminizin tamamlanabilmesi için telefonunuza gönderilen 6 basamaklı doğrulama kodunu giriniz"
          >
            <Input style={{width : '50%'}} />
          </Form.Item>
        )}
        <Form.Item>
          <Row>
            <Col span={24} style={{ textAlign: "right" }}>
              <Button
                style={{ margin: "0 8px" }}
                type="primary"
                htmlType="submit"
              >
                {hasVerify ? "Kaydet" : "Devam"}
              </Button>
            </Col>
          </Row>
        </Form.Item>
      </Form>
    </Spin>
  );
};

export default KullaniciEkleForm;
